module.exports = __webpack_public_path__ + "static/media/helpcard2.dd5ac81c.svg";